import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { BookOpenText } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// 竞赛/活动规则 PDF（取 assets/document 下首个 PDF），登录页「活動介紹」按钮弹窗复用
const rulesPdfModules = import.meta.glob('../assets/document/*.pdf', { eager: true, query: '?url', import: 'default' });
const rulesPdfUrl = Object.values(rulesPdfModules)[0] as string;

// 手机横屏(高≤500)判定：与 CSS [@media(max-height:500px)] 同断点，用于横屏时去掉
// ui/dialog 默认注入的空标题(showTitle)。本地实现，避免把 dashboard 外壳耦合进登录包。
function useShortViewport() {
  const [is, setIs] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-height: 500px)').matches,
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-height: 500px)');
    const on = () => setIs(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return is;
}

// 把传入的子元素作为 DialogTrigger，点击后弹出比赛/活动详情 PDF。
// 登录页顶部「活動介紹」胶囊与其他入口共用同一份内容。
export function CompetitionRulesDialog({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const isShort = useShortViewport();
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      {/* 手机横屏(高≤500)：镜像 dashboard 顶栏「規則」弹窗，等比缩到 292×374 贴合 390 舞台，
          去掉默认空标题、收紧内边距/间距；仅 max-height:500px 生效，桌面 showTitle 仍为 true，不动电脑/平板。 */}
      <DialogContent
        showTitle={!isShort}
        className="sm:max-w-3xl h-[85vh] flex flex-col [@media(max-height:500px)]:!w-[292px] [@media(max-height:500px)]:!max-w-[292px] [@media(max-height:500px)]:!h-[min(374px,calc(100vh-1rem))] [@media(max-height:500px)]:!px-4 [@media(max-height:500px)]:!pt-4 [@media(max-height:500px)]:!pb-4 [@media(max-height:500px)]:!gap-2.5"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg font-semibold">
            <BookOpenText className="h-5 w-5 text-primary" />
            {t("user.competition-rules-title")}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-auto rounded-lg border">
          <iframe
            src={rulesPdfUrl}
            className="w-full h-full"
            title={t("user.competition-rules-title")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CompetitionRulesDialog;
